<template>
  <v-layout class="pl-wrapper" column justify-center fill-height>
    <v-layout class="pl-wrapper" column justify-center fill-height v-show="load || loading">
      <preloader />
    </v-layout>

    <v-layout class="pl-wrapper" column justify-center fill-height v-show="!load && !loading">
      <slot> </slot>
    </v-layout>
  </v-layout>
</template>

<script>
import Preloader from '@/components/Preloader/Preloader'
import { mapGetters } from 'vuex'

export default {
  name: 'wrapper',
  components: {
    preloader: Preloader,
  },
  computed: {
    ...mapGetters(['load']),
  },
  props: ['loading'],
}
</script>
